import React from 'react';
import {motion} from 'framer-motion';
import {useAuth} from '../context/AuthContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiSun,FiBarChart3,FiSettings,FiLogOut,FiTree,FiActivity,FiMail}=FiIcons;

const Sidebar=({currentPage,setCurrentPage})=> {
  const {logout,user}=useAuth();

  const menuItems=[ 
    {id: 'dashboard',label: 'Dashboard',icon: FiBarChart3},
    {id: 'plants',label: 'Anlagen verwalten',icon: FiSettings},
    {id: 'environmental',label: 'Umweltauswirkungen',icon: FiTree},
    {id: 'inverter-checks',label: 'WR-Prüfungen',icon: FiActivity},
    {id: 'email-tests',label: 'E-Mail Tests',icon: FiMail},
  ];

  return (
    <motion.div 
      initial={{x: -300}} 
      animate={{x: 0}} 
      transition={{duration: 0.5}} 
      className="w-64 bg-white shadow-lg flex flex-col"
    >
      <div className="p-6 border-b border-gray-200">
        <div className="flex items-center space-x-3">
          <div className="bg-gradient-to-r from-solar-400 to-solar-600 w-10 h-10 rounded-lg flex items-center justify-center">
            <SafeIcon icon={FiSun} className="text-white text-xl" />
          </div>
          <div>
            <h1 className="text-xl font-bold text-gray-900">PV Dashboard</h1>
            <p className="text-sm text-gray-500">Solar Management</p>
          </div>
        </div>
      </div>

      <nav className="flex-1 p-4">
        <ul className="space-y-2">
          {menuItems.map((item)=> (
            <li key={item.id}>
              <motion.button
                whileHover={{scale: 1.02}} 
                whileTap={{scale: 0.98}}
                onClick={()=> setCurrentPage(item.id)} 
                className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg text-left transition-colors ${
                  currentPage===item.id 
                    ? 'bg-primary-50 text-primary-700 border border-primary-200' 
                    : 'text-gray-700 hover:bg-gray-50'
                }`}
              >
                <SafeIcon icon={item.icon} className="text-lg" />
                <span className="font-medium">{item.label}</span>
              </motion.button>
            </li>
          ))}
        </ul>
      </nav>

      <div className="p-4 border-t border-gray-200">
        <div className="flex items-center justify-between mb-4">
          <div>
            <p className="text-sm font-medium text-gray-900">{user?.username}</p>
            <p className="text-xs text-gray-500">Administrator</p>
          </div>
        </div>
        <motion.button
          whileHover={{scale: 1.02}} 
          whileTap={{scale: 0.98}}
          onClick={logout} 
          className="w-full flex items-center space-x-2 px-4 py-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
        >
          <SafeIcon icon={FiLogOut} />
          <span>Abmelden</span>
        </motion.button>
      </div>
    </motion.div>
  );
};

export default Sidebar;